'use client'

import {
  useStoreContact,
  useStoreI18n,
  useStoreIntegrations,
  useStoreNavigation
} from '@/store'
import { Typo3_834 } from '@/types'
import { Locale } from '@spot'
import { useLenis } from 'lenis/react'
import { usePathname } from 'next/navigation'
import React, { memo, useEffect, useEffectEvent, useLayoutEffect } from 'react'
import BottomNav from '../BottomNav/BottomNav'
import LenisScroll from '../LenisScroll/LenisScroll'

interface Props {
  children: React.ReactNode
  data: Typo3_834
  lang?: Locale
  header: React.ReactNode
}

const Layout = ({ children, data, lang, header }: Props) => {
  //hooks
  const pathname = usePathname()

  //stores
  const { setContact } = useStoreContact()
  const { setIntegrations } = useStoreIntegrations()
  const { setCurrentLocale, setDictionary } = useStoreI18n()
  const { isRouteTransition, setIsRouteTransition } = useStoreNavigation()
  const lenis = useLenis()

  const handlePathname = useEffectEvent(() => {
    if (lenis) {
      lenis?.scrollTo(0, { immediate: true })
    }
    setIsRouteTransition(false)
  })

  useEffect(() => {
    handlePathname()
  }, [pathname])

  useEffect(() => {
    setCurrentLocale(lang as Locale)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang])

  //Generate Dictionary
  useLayoutEffect(() => {
    setDictionary(data?.locallang?.[0])
    setContact(data?.footer?.contacts)
    setIntegrations(data?.integrations ?? null)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <>
      <LenisScroll>
        {header}
        <main id="main-content" className="page-wrapper">
          <div className="main-wrapper" data-transition={isRouteTransition}>
            {children}
          </div>
        </main>
        <BottomNav data={data?.header} />
      </LenisScroll>
    </>
  )
}

export default memo(Layout)
